import { createAsyncThunk } from '@reduxjs/toolkit';
import { ICategory } from '../types';
import otherManagementServices from '../otherManagementServices';
import { batch } from 'react-redux';
import { otherManagementActions } from '.';
import { toastActions } from 'pages/_commons/Toast/_redux';

export const deleteCategory = createAsyncThunk<
  unknown,
  ICategory,
  ThunkAPIConfig
>('deleteCategory', async (args, { dispatch, rejectWithValue }) => {
  try {
    await otherManagementServices.deleteCategory(args);

    return batch(() => {
      dispatch(
        toastActions.addToast({
          show: true,
          message: '성공',
          type: 'success'
        })
      );
      dispatch(
        otherManagementActions.getCategories({
          limit: 5
        })
      );
      dispatch(otherManagementActions.setReportAction('list'));
      dispatch(otherManagementActions.setSelectedReport());
    });
  } catch (error) {
    dispatch(
      toastActions.addToast({
        show: true,
        message: '오류',
        type: 'error'
      })
    );
    return rejectWithValue(error);
  }
});
